const CONFIG = {
  SENTRY: {
    dsn:
      window.namespaceEnv === 'production'
        ? 'https://014c885eeece011b0332cdcc648f7663@sentry.banksalad.com/11'
        : 'https://1b11fd29833dc00b371af7c28d4d0094@sentry-v2.staging.banksalad.com/22',
    release: COMMIT_SHA,
    environment: window.namespaceEnv,
  },
};

export { CONFIG };
